import React from 'react'
import { Typography } from './Typography'

export const Divider = ({ text, mt }: { text: string; mt?: 'mt-[24px]' }) => {
  return (
    <div className={`mx-auto mb-[20px] ${mt} flex w-11/12 items-center justify-center`}>
      <div className="h-[0.5px] w-[80%] bg-[#666]" />
      <Typography variant="caption2" component="span" c="#666666" className="mx-[6px] whitespace-nowrap text-center">
        {text}
      </Typography>
      <div className="h-[0.5px] w-[80%] bg-[#666]" />
    </div>
  )
}
